import React, { useState, useCallback } from "react";
import FilterButton from "../../../../src/ui/buttons/FilterButton";
import UploadNewBatch from "./UploadNewBatch";
import LigationBatchFilter from "./LigationBatchFilter";

function LitigationBatchHeader({ setSearchParameter, setHitReload }) {
    const [SortAsc, setSortAsc] = useState(true);

    // filter
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState({});

    const [showUploadNewBatchModal, setShowUploadNewBatchModal] = useState(false);

    const handleApplyFilters = useCallback((filters) => {
        setFilterData(filters);
        // Map the filters to API parameters
        const apiParams = {};
        
        if (filters.client) {
            apiParams.client = filters.client;
        }
        
        if (filters.batchName) {
            apiParams.batch_name = filters.batchName;
        }
        
        setSearchParameter(apiParams);
    }, [setSearchParameter]);

    const handleSort = () => {
        setSortAsc(!SortAsc);
        let sort = SortAsc ? "asc" : "dsc";
        setSearchParameter({ sort });
    };

    const handleDownloadBulkFile = () => {
        // Download functionality - to be implemented
        console.log("Download Bulk Batch File clicked");
        // You can add your download logic here
    };

    return (
        <div className="row d-flex d-wrap justify-between filter-section">
            <div className="d-flex d-wrap align-items-center justify-content-between gap-4">
                <div className="d-flex align-center">
                    <FilterButton 
                        onClick={() => setShowFilter(true)} 
                        active={!!filterData && !!Object.values(filterData)?.some((el) => !!el)} 
                    />
                </div>

                <div className="d-wrap d-flex align-items-center justify-content-end gap-2">
                    {/* Upload New Batch File Button */}
                    <button 
                        className="btn btn-primary btn-lg ms-2" 
                        onClick={() => setShowUploadNewBatchModal(true)}
                    >
                        <svg width="14" height="17" xmlns="http://www.w3.org/2000/svg" className="me-2">
                            <g fill="currentColor" fillRule="evenodd">
                                <path d="M.903 8.201a.7.7 0 0 1 1.4 0v5.601a.7.7 0 0 0 .701.7h8.405a.7.7 0 0 0 .7-.7v-5.6a.7.7 0 0 1 1.4 0v5.6a2.1 2.1 0 0 1-2.1 2.1H3.004a2.1 2.1 0 0 1-2.101-2.1v-5.6zM7.206 2.19 4.9 4.497a.7.7 0 0 1-.99-.99L6.71.706a.7.7 0 0 1 .99 0l2.802 2.8a.7.7 0 1 1-.99.99L7.206 2.19z" />
                                <path d="M6.506 1.2a.7.7 0 0 1 1.4 0v9.102a.7.7 0 0 1-1.4 0V1.2z" />
                            </g>
                        </svg>
                        Upload New Batch File
                    </button>
                </div>
            </div>

            {/* Filter Modal */}
            <LigationBatchFilter
                show={showFilter}
                close={() => setShowFilter(false)}
                onApplyFilters={handleApplyFilters}
                currentFilters={filterData}
            />

            {/* Upload New Batch Modal */}
            <UploadNewBatch
                show={showUploadNewBatchModal}
                setShow={setShowUploadNewBatchModal}
                reload={() => {
                    setHitReload((prev) => !prev);
                }}
            />
        </div>
    );
}

export default LitigationBatchHeader;